





















































































import { defineComponent, ref, computed } from "@vue/composition-api";
import { IconCardGrid } from "@/components.generic/icon-card-grid";
import { TagSidebar } from "@/components.tags/tag-sidebar";
import { getInverseColor } from "@/utils/color";
import { useTags } from "@/hooks/useTags";
import { useAssets } from "@/hooks/useAssets";
import { sortByDate } from "@/utils/array";
import { StudyList } from "@/components.studies/study-list";
import { CreateStudyWizard } from "@/components.studies/create-study-wizard";
import { default as BlueprintGrid } from "./blueprint-grid.vue";
import * as Utils from "./utils";
import { useTranslate } from "@lang";
import { AbsBox, Icon, Heading, Container, Divider, SearchFilter } from "@ui";
import { ContextHeader } from "@/components.nav/context-header";

export default defineComponent({

	components: {
		AbsBox,
		IconCardGrid,
		TagSidebar,
		StudyList,
		CreateStudyWizard,
		BlueprintGrid,
		SearchFilter,
		Divider,
		Container,
		Heading,
		Icon,
		ContextHeader,
	},
	beforeRouteUpdate(to:any, from:any, next:any){ // note: hack until vue-router uses composition api
		const t = to.query["t"];
		if(this.currentTagId !== t){
			this.setCurrentTag(t);
		}
		next();
	},
	setup(_, context){

		const createStudyWizard = ref<any>();
		const studiesList = ref<any>();

		const searchFilter = ref(Utils.getQueryValue("filter", context, ""));

		const { assets } = useAssets();

		const { translate } = useTranslate();

		const {
			sortedTags,
			hasTag,
		} = useTags();

		const blueprints = computed(() => {
			const tag = currentTagId.value;
			const blueprints = assets.value.filter(a => a.type === "Graph");
			sortByDate(blueprints, a => a.lastModified);
			// if(tag === "all"){ return blueprints; }
			// if(!tag){ return blueprints.filter(bp => !hasAnyTag(bp._id)); }
			// if(tag === "all"){ return blueprints; }
			if(!tag){ return blueprints; }

			return blueprints.filter(bp => hasTag(tag, bp._id));
		});

		const currentTagId = ref<string|null>(null);

		const currentTag = computed(() => {
			return sortedTags.value.find(t => t._id === currentTagId.value);
		});
		
		const getBlueprintRoute = (blueprintId:string) => {
			return {
				name: "Run.Study",
				params:{
					studyId:blueprintId
				},
				query:{
					...context.root.$route.query
				}
			}
		};

		const setCurrentTag = (v:string) => {
			currentTagId.value = v;
		};


		const createStudy = (blueprintId:string) => {
			if(!createStudyWizard.value){ return; }
			createStudyWizard.value.open(blueprintId, async (r:any) => {
			});
		};

		const init = async() => {
			const t = context.root.$route.query["t"];
			if(t && typeof(t) === "string"){
				currentTagId.value = t;
			}
		};

		const saveSearch = () => {
			const sv = searchFilter.value.length > 0 ? searchFilter.value : undefined;
			Utils.setQueryValue("filter", sv, context);
		};

		const clearSearch = () => {
			searchFilter.value = '';
			Utils.setQueryValue("filter", undefined, context);
		};

		init();

		return {
			searchFilter,
			createStudyWizard,
			blueprints,
			currentTagId,
			currentTag,
			studiesList,
			translate,
			getBlueprintRoute,
			setCurrentTag,
			getInverseColor,
			createStudy,
			clearSearch,
			saveSearch,
		};

	}

});
